import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'AvmDateAndTime',
    standalone: true,
})
export class AvmDateAndTimePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    /**
     * Formate une date.
     * @param date : Date à formatter
     */
    transform(date: Date): string {
        console.log('AvmDateAndTime', date);
        if (date) {
            return this.datePipe.transform(date, 'dd/MM/YYYY HH:mm:ss');
        } else {
            return '-';
        }
    }
}
